var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"Header shadow",class:{ 'is-close': _vm.closeSidebar},attrs:{"fixed":"top"}},[_c('div',{staticClass:"Header-PageTitle"},[_vm._v(_vm._s(_vm.pageTitle))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }